// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "mg-mczx/static/css/" + chunkId + "." + {"257":"31b68baa","564":"b67a0522","786":"75daa0f7"}[chunkId] + ".css";
};